<template>
  <div>
    <v-list>
      <template v-for="(item, i) in items" :key="i">
        <div v-if="itemObject(item) !== undefined">
          <v-list-item>
            <template #default>
              <v-list-item-content>
                <div class="py-2">
                  <v-list-item-title>
                    <slot name="text" :itemObject="itemObject(item)">
                      {{ itemObject(item)[itemText] }}
                    </slot>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <slot name="detail" :itemObject="itemObject(item)">
                      {{ itemObject(item)[itemDetail] }}
                    </slot>
                  </v-list-item-subtitle>
                </div>
              </v-list-item-content>
            </template>

            <template #append>
              <v-list-item-action v-if="i > 0" title="Nach oben verschieben">
                <v-btn icon variant="text" size="small" @click="moveUp(i)">
                  <v-icon color="grey-lighten-1">mdi-chevron-up</v-icon>
                </v-btn>
              </v-list-item-action>

              <v-list-item-action
                v-if="i < items.length - 1"
                title="Nach unten verschieben"
              >
                <v-btn icon variant="text" size="small" @click="moveDown(i)">
                  <v-icon color="grey-lighten-1">mdi-chevron-down</v-icon>
                </v-btn>
              </v-list-item-action>

              <v-list-item-action title="Löschen">
                <v-btn icon variant="text" size="small" @click="remove(i)">
                  <v-icon color="grey-lighten-1">mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider v-if="i < items.length - 1" />
        </div>
      </template>
    </v-list>

    <div
      class="font-italic text-center text-grey my-5"
      v-if="!items || items.length === 0"
    >
      Es sind keine Einträge vorhanden.
    </div>

    <v-autocomplete
      v-model="addItemValue"
      :items="unselectedItems"
      :item-value="itemValue"
      :item-title="itemText"
      placeholder="Ein weiteres Element Hinzufügen"
      hide-details
      variant="underlined"
    >
      <template #append>
        <v-btn size="small" color="primary" @click="add">
          <v-icon>mdi-plus</v-icon>
          Hinzufügen
        </v-btn>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "SortableList",
  props: {
    items: { type: Array, default: () => [] },
    availableItems: { type: Array, default: () => [] },
    itemValue: { type: String, required: true },
    itemText: { type: String, required: true },
    itemDetail: { type: String, required: true },
  },

  data() {
    return {
      addItemValue: null,
    };
  },

  methods: {
    moveUp(index) {
      if (index > 0) {
        const item = this.items[index];
        this.items.splice(index, 1);
        this.items.splice(index - 1, 0, item);
      }
    },
    moveDown(index) {
      if (index < this.items.length - 1) {
        const item = this.items[index];
        this.items.splice(index, 1);
        this.items.splice(index + 1, 0, item);
      }
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    add() {
      if (this.addItemValue != null) {
        this.items.push(this.addItemValue);
        this.addItemValue = null;
      }
    },
    itemObject(id) {
      return this.availableItems.find((item) => item[this.itemValue] === id);
    },
  },

  computed: {
    unselectedItems() {
      return this.availableItems.filter(
        (item) => !this.items.includes(item[this.itemValue])
      );
    },
  },
};
</script>

<style scoped>
.v-list-item-action {
  margin-left: 8px;
}
</style>
